module.exports = __webpack_public_path__ + "img/1.d1dbaad9.jpg";